import { createContext, useContext, type ReactNode } from 'react';
import { useShopReminderCounts, type QueuedReminder } from '@/hooks/useShopReminderCounts';

interface ReminderCountsContextValue {
  remindersByTicket: Map<string, QueuedReminder[]>;
  isLoading: boolean;
}

const ReminderCountsContext = createContext<ReminderCountsContextValue>({
  remindersByTicket: new Map(),
  isLoading: true,
});

export function ReminderCountsProvider({ shopId, children }: { shopId: string | undefined | null; children: ReactNode }) {
  const value = useShopReminderCounts(shopId);
  return (
    <ReminderCountsContext.Provider value={value}>
      {children}
    </ReminderCountsContext.Provider>
  );
}

export function useReminderCounts() {
  return useContext(ReminderCountsContext);
}
